import microuniversoApi from "app/api/microuniversoApi"
import { useAppSelector } from "app/redux/hooks"
import { DescontoOrcamento } from "app/types/Desconto"
import { IOrcamento } from "app/types/IOrcamento"
import { tratamentoErroPadrao } from "app/use-cases"
import { aplicarDescontosAdicionais as aplicarDescontosAdicionaisUseCase, } from "app/use-cases/orcamento/alterarDesconto"
import globalMU from "globalMU"
import React, { useEffect, useState } from "react"
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container"
import { Descontos } from "./Descontos"

export const DescontosContainer = () => {
  const orcamento: IOrcamento = useAppSelector((store) => store.orcamento);
  const [dadosDeDesconto, setDadosDeDesconto] = useState<DescontoOrcamento>();
  const [dadosDeDescontoIniciais, setDadosDeDescontoIniciais] = useState<DescontoOrcamento>();

  const onObterDadosDesconto = async () => {
    try {
      globalMU.blockUI();
      const resultado = await microuniversoApi.Orcamento.dadosDescontos(orcamento.IdentificadorOrcamento);
      !("HasErrors" in resultado) && (
        setDadosDeDesconto(resultado),
        setDadosDeDescontoIniciais({
          ...resultado,
          DescontoMaximoFormaPagamento: resultado.DescontoMaximoFormaPagamentoOriginal,
          DescontoFretePorContaDestinatario: resultado.DescontoFretePorContaDestinatarioOriginal,
          DescontoPorFaixaValorVenda: resultado.DescontoPorFaixaValorVendaOriginal,
          DescontoAdicionalProdutoSemOferta: resultado.DescontoAdicionalProdutoSemOfertaOriginal,
          DescontoAdicionalProdutoComOferta: resultado.DescontoAdicionalProdutoComOfertaOriginal
        })
      )
    } catch (e) {
      tratamentoErroPadrao(e)
    } finally {
      globalMU.unblockUI();
    }
  };

  const onLimparDesconto = () => {
    setDadosDeDesconto({
      ...dadosDeDesconto,
      DescontoMaximoFormaPagamento: 0.00,
      DescontoFretePorContaDestinatario: 0.00,
      DescontoPorFaixaValorVenda: 0.00,
      DescontoAdicionalProdutoSemOferta: 0.00,
      DescontoAdicionalProdutoComOferta: 0.00
    });
  }

  const onAplicarDescontoOriginal = () => {
    setDadosDeDesconto(dadosDeDescontoIniciais);
  }

  const atualizaDadosDeDesconto = (dados: DescontoOrcamento) => {
    setDadosDeDesconto(dados);
  }

  const aplicarDescontos = async (descontos: DescontoOrcamento) => {
    try {
      globalMU.blockUI();
      await aplicarDescontosAdicionaisUseCase({ descontos })
    } catch (e) {
      tratamentoErroPadrao(e)
    } finally {
      globalMU.unblockUI();
    }
  };

  useEffect(() => {
    onObterDadosDesconto();
  }, [])

  return (
    <>
      <Breadcrumb2Container
        passos={["Descontos Adicionais"]}
        exibirBotaoLimpar={true}
        exibirBotaoVoltar={false}
        onBotaoLimparClicado={onLimparDesconto}
        id="DescontosAdicionaisBreadcrumb"
      />

      <Descontos
        somenteLeitura={orcamento.SomenteLeitura}
        dadosDeDesconto={dadosDeDesconto}
        descontosOriginais={onAplicarDescontoOriginal}
        onAplicar={aplicarDescontos}
        onErrorValidacao={(mensagemErro) => globalMU.showErrorMessage(mensagemErro)}
        onAtualizarDadosDesconto={atualizaDadosDeDesconto} />
    </>

  )

}